import $ from 'jquery';

function faqAccordion() {
  $(document).on('click', '.js-accordion-trigger', function (event) {
    event.stopPropagation();
    var p = $(this).parent().parent();

    var panel = $(this).next('.js-accordion__panel');
    
    $(this).parent().attr('aria-expanded', 'true')

    if (panel.hasClass('accordion__panel--hide')) {
      panel.animate({ height: panel[0].scrollHeight }, 200, function () {
        panel.removeClass('accordion__panel--hide');
        p.removeClass('blocked');
        p.addClass('open');
      });
    } else {
      panel.animate({ height: 0 }, 200, function () {
        panel.addClass('accordion__panel--hide');
        p.removeClass('open');
        $(this).parent().attr('aria-expanded', 'false');
      });
    }
  });
}

export default faqAccordion;
